import axios from 'http.service';
import apiErrorMsg from 'Common/Utils/apiErrorMsg';

function buildPagingQuery(sortOrder, sortField, forExport, page, pageSize) {
    const query = {
        sortOrder: sortOrder,
        sortField: sortField,
        page: forExport ? 0 : page,
        sizePerPage: forExport ? 0 : pageSize,
        searchText: '',
        flagExportData: forExport || false
    };
    return query;
}

async function getResource(url, errorCallback, dataAlias) {
    try {
        const resp = await axios.get(url);
        return processResponse(resp, errorCallback, dataAlias);
    } catch (err) {
        return processError(err, errorCallback);
    }
}

const isSuccessful = (status) => status === 200 || status === 201 || status === 204 || status === 304;

function processResponse(resp, errorCallback, dataAlias = 'data') {
    const { status, data: content } = resp;
    if (status === 204) {
        const empty = [];
        empty.totalCount = 0;
        return empty;
    }

    if (isSuccessful(status)) {
        let items = [];
        let totalCount;
        if (content?.[dataAlias]?.[0]?.data) {
            // e.g. content = { data: [{ total: 2, data: [item1, item2], errors: [] }] }
            items = content[dataAlias][0].data;
            totalCount = content[dataAlias][0].total;
        } else if (content?.[dataAlias]?.data) {
            // e.g. content = { data: { total: 2, data: [item1, item2], errors: [] } }
            items = content[dataAlias].data;
            totalCount = content[dataAlias].total;
        } else if (content?.[dataAlias]?.[0]) {
            // e.g. content = { data: [item1, item2], errors: [] }
            items = content[dataAlias];
        }

        items.totalCount = totalCount || items.length;
        return items;
    }

    const errors = (content?.[0]?.errors) || [];
    const errorMessage = apiErrorMsg(status, errors);
    return errorCallback(errorMessage);
}

function processError(error, errorCallback) {
    if (error.response) {
        return errorCallback(apiErrorMsg(error.response.status, error.response.data));
    }

    return errorCallback(error.message || error);
}

export { buildPagingQuery, getResource, isSuccessful, processResponse, processError };